'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var origSymbol = global.Symbol;

var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }

  if (typeof Symbol !== 'function') {
    return false;
  }

  if ((0, _typeof2["default"])(origSymbol('foo')) !== 'symbol') {
    return false;
  }

  if ((0, _typeof2["default"])(Symbol('bar')) !== 'symbol') {
    return false;
  }

  return hasSymbolSham();
};